import colors from "@/styles/colors";

export default function ArrowDownIcon(props: React.SVGProps<SVGSVGElement>) {
    const { color = colors.blackLight } = props;
    return (
       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8.5L12 14.5L18 8.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    )
}